import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
  useEffect(() => {
    // allowNestedScroll: inner scrollables (textareas, chat panes, doc lists, code
    // blocks) scroll natively on wheel — without it Lenis swallows the wheel page-wide
    // and users are stuck dragging tiny scrollbars.
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, allowNestedScroll: true });

    // Capture-phase shield: Lenis's wheel listener lives on window in the bubble phase
    // and has proven unreliable at honoring data-lenis-prevent / nested scroll for some
    // controls (notably textareas). Any wheel event whose path includes a marked element
    // is stopped here — before Lenis ever sees it — so native scrolling proceeds.
    const shield = (e) => {
      const path = e.composedPath ? e.composedPath() : [];
      for (const node of path) {
        if (node instanceof HTMLElement && node.hasAttribute("data-lenis-prevent")) {
          e.stopImmediatePropagation();
          return;
        }
      }
    };
    window.addEventListener("wheel", shield, { capture: true, passive: true });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("wheel", shield, { capture: true });
      lenis.destroy();
    };
  }, []);
  return children;
}
